module.exports = __webpack_public_path__ + "static/media/check.9c735fca.svg";